import { StudentRepository } from '@/domain/student-repository';
import AccountPageTracker from './tracking';
import { PortalType } from '@studyportals/authentication-service-interfaces';
import { ModalManager } from '@studyportals/modal';
import { IEventAggregationService } from '@studyportals/event-aggregation-service-interface';
import JourneyTracker from '@/presentation/components/Views/Journey/JourneyTracker';

const accountPageTracker = new AccountPageTracker();
const monetBaseURL = '//monet-prtl-co.imgix.net/Shared/AccountPage';
const portalType: PortalType = (window['PortalType'] as PortalType) ?? PortalType.MASTERS;
const eventAggregationService: IEventAggregationService = {} as IEventAggregationService;
// set in dependency checker plugin
const studentRepository: StudentRepository = {} as StudentRepository;
const modalManager: ModalManager = {} as ModalManager;
const journeyTracker = new JourneyTracker();

export default {
	accountPageTracker,
	monetBaseURL,
	portalType,
	eventAggregationService,
	studentRepository,
	modalManager,
	journeyTracker,
};
